import React, { Dispatch, useCallback } from 'react';
import Icon from '@mdi/react';
import { useDispatch } from 'react-redux';
import { setDndActive } from '../../../redux/general/sliceDragDrop';
import { Box } from '@mui/material';

const icon = {
    path: 'M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z',
};

export default ({ visible }: { visible: boolean }) => {
    const dispatch: Dispatch<unknown> = useDispatch();

    const onDragStart = useCallback((e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault(); // prevent standard DND cursor
        window.addEventListener('mouseup', onMouseUp);

        document.body.style.cursor = 'grabbing';
        dispatch(setDndActive('documentCategorization'));
    }, []);

    const onMouseUp = useCallback(() => {
        window.removeEventListener('mouseup', onMouseUp);

        document.body.style.cursor = 'default';
        dispatch(setDndActive(false));
    }, []);

    if (!visible) {
        return (
            <Box
                sx={{
                    width: 24,
                }}
            />
        );
    }

    return (
        <Box
            draggable
            onDragStart={onDragStart}
            sx={{ cursor: 'grab', width: '24px', '&:active': { cursor: 'grabbing' } }}
        >
            <Icon path={icon.path} size={1} style={{ verticalAlign: 'middle' }} />
        </Box>
    );
};
